import { forwardRef, useEffect } from 'react';
import { HTMLSnippet } from '@namespace/snippets';

import styles from './index.module.css';

const PromoTeaser = forwardRef(
  ({ className = '', snippetId, handleClickOnMove, gap }, ref) => {
    useEffect(() => {
      if (!ref.current) {
        return;
      }

      ref.current.addEventListener('click', handleClickOnMove, true);

      // eslint-disable-next-line consistent-return
      return () => {
        if (ref.current) {
          ref.current.removeEventListener('click', handleClickOnMove, true);
        }
      };
    }, [ref, handleClickOnMove]);

    return (
      <div
        data-role={`promo-teaser-${snippetId}`}
        ref={ref}
        onClick={handleClickOnMove}
        className={`${styles.teaser} ${className}`}
        style={gap && { marginRight: gap }}
      >
        <HTMLSnippet snippetId={snippetId} />
      </div>
    );
  }
);

export default PromoTeaser;
